<div *ngIf="!loading && !results.length" class="no-results">
  {{ noResultsLabel }}
</div>

<div class="results-list" *ngIf="results.length">
  <app-result-item
    *ngFor="let item of results; let i = index"
    [item]="item"
    [hideFacets]="hideFacets"
    [position]="i"
    (resultClick)="resultClick.emit($event)"
  ></app-result-item>
</div>
